import { Badge } from "V2.0/common/badge";
import {
  VoiceAssistantNodeResult,
  voiceAssistantNodeResultConfig,
} from "V2.0/HomePages/PipelinesV2/PipelineBuilderV2/Models/Assistant";

export default VoiceCallActionResults;

function VoiceCallActionResults(props) {
  const { onSelect } = props;

  return (
    <div className="flex flex-col gap-y-4">
      {Object.values(voiceAssistantNodeResultConfig).map((result, idx) => {
        return (
          <Badge
            color={result.color}
            key={result.outputPort}
            className="hover:cursor-pointer"
            onClick={() => onSelect(result)}
          >
            {result.label}
          </Badge>
        );
      })}
    </div>
  );
}
